const MEDIA = {
    mobile: "767px",
    tablet: "1024px",
    laptop: "1400px",
    desktop: "1920px",
};

const COLOR = {
    white: "#fff",
    black: "#000",
    gray: {
        100: "#f8f8f8",
        200: "#dcdcdc",
        300: "#cbcbcb",
        400: "#a8a8a8",
        500: "#6b6b6b",
    },
    negative: "#8d3333",
    positive: {
        100: "#7BC333",
        200: "#608D33",
    },
    blue: {
        200: "#749FA5",
        300: "#3B6C8D",
    },
    mint: {
        100: "#e5f5f7",
    },
    pink: {
        100: "#FCF2E8",
        200: "#dd107f",
    },
    brown: {
        100: "#f5f3ef",
        200: "#cac19f",
    },
    none: "",
};

const theme = {
    MEDIA,
    COLOR,
};

export default theme;
